
<template>
    <div class="container1">
		<div class="cusos-search">
			<div class="search-box">
				<div class="input-box">
					<span>客户名称：</span>
					<el-input
						v-model="cusName"
						placeholder="请输入客户名称"
						class="name-input"
						@keyup.enter.native="search"
						size="mini"
					></el-input>
				</div>
				<div class="input-box">
					<span>商品名称：</span>
					<el-input
						v-model="pName"
						placeholder="请输入商品名称"
						class="name-input"
						@keyup.enter.native="search"
						size="mini"
					></el-input>
				</div>
				<div class="input-box">
					<span>客户类别：</span>
					<el-select v-model="customercategoryIds" class="name-input" size='mini'>
						<el-option value="" label="全部"></el-option>
						<el-option v-for="item in cusCateList" :value="item.ccid" :label="item.ccname" :key="item.ccid"></el-option>
					</el-select>
				</div>
				<div class="input-box">
					<span>店铺级大类：</span>
					<el-select v-model="bigTypeCategory" class="name-input" size='mini' @change="bcChange">
						<el-option value="0" label="全部"></el-option>
						<template v-for="(item) in bc">
							<el-option :value="item.bc_id" :label="item.bc_name" :key="item.bc_id"/>
						</template>
					</el-select>
				</div>
				<div class="input-box" v-if="bigcategoryview === 1">
					<span>店铺级小类：</span>
					<el-select v-model="smallTypeCategory" class="name-input" size='mini'>
						<el-option value="0" label="全部"></el-option>
						<template v-for="(item) in sc">
							<el-option :value="item.id" :label="item.name" :key="item.id"></el-option>
						</template>
					</el-select>
				</div>
				<div class="input-box">
					<span>SPU编号：</span>
					<el-input
						v-model="pcode"
						placeholder="请输入SPU编号"
						class="name-input"
						@keyup.enter.native="search"
						size="mini"
					></el-input>
				</div>
				<div class="input-box">
					<span>销售门店：</span>
					<el-select
						size="mini"
						class="name-input"
						v-model="shopIds"
						filterable
						multiple
						collapse-tags
						placeholder="请选择门店名称">
						<template v-for="item in shopNameList">
							<el-option
								:key="item.id"
								:label="item.name"
								:value="item.id">
							</el-option>
						</template>
					</el-select>
				</div>
				<div class="input-box">
					<span>三方编号：</span>
					<el-input
						v-model="matchcode"
						placeholder="请输入三方编号"
						class="name-input"
						@keyup.enter.native="search"
						size="mini"
					></el-input>
				</div>
			</div>
			<div class="input-box-btn">
				<el-button type='primary' size='mini' class="fx-btn" style="margin-left:0" @click="search">查询</el-button>
				<el-button plain size='mini' class="fx-btn" @click="clear">清空</el-button>
			</div>
		</div>
		<div class="btn-ship-box">
			<el-button type='primary' v-if="AuthorityList['03_0006_0001_00']" plain size='mini' class="fx-big-btn" @click="addClick">添加商品</el-button>
			<el-button type='primary' v-if="AuthorityList['03_0006_0005_00']" plain size='mini' @click='mutiCLick'>批量设置</el-button>
			<el-button type='primary' v-if="AuthorityList['03_0006_0002_00']" plain size='mini' @click='synchroClick'>同步到其他客户</el-button>
			<el-button type='primary' v-if="AuthorityList['03_0006_0004_00']" plain size='mini' @click="deleteListClick" class="fx-big-btn">删除</el-button>
		</div>
		<div class='table-box'>
			<el-table
				size='mini'
				class="grid-content"
				:data="tableData"
				:height="tableHeight"
				ref="table"
				@select="handleSelectionChange"
				@select-all="handleSelectionChange"
				border>
				<el-table-column
					type="selection"
					align="center"
					width="55">
				</el-table-column>
				<el-table-column
					label="客户名称"
					prop='customerName'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="客户类别"
					prop='ccName'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="商品名称"
					prop='productName'
					min-width="180"
					align="center">
					<template slot-scope="scope">
						<div style="white-space: pre-wrap">{{scope.row.productName}}</div>
					</template>
				</el-table-column>
				<el-table-column
					label="店铺级大类"
					prop='bigCategoryName'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					v-if="bigcategoryview === 1"
					label="店铺级小类"
					prop='smallCategoryName'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="销售门店"
					prop='shopName'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="SPU编号"
					prop='productCode'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="三方编号"
					prop='prodcutMatchCode'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="订货周期"
					prop='orderGoodsDate'
					min-width="180"
					align="center">
					<template slot-scope="scope">
						<div style="white-space: pre-wrap" v-if="scope.row.orderGoodsType === 0">每天订货</div>
						<div style="white-space: pre-wrap" v-if="scope.row.orderGoodsType === 1">每周{{scope.row.orderGoodsDate}}订货</div>
						<div style="white-space: pre-wrap" v-if="scope.row.orderGoodsType === 2">每月{{scope.row.orderGoodsDate}}日订货</div>
						<div style="white-space: pre-wrap" v-if="scope.row.orderGoodsType === 2 && scope.row.monthEndFlag === 1">每月月末最后一天订货</div>
						<div style="white-space: pre-wrap" v-if="scope.row.orderGoodsType === 2 && scope.row.unflag === 1">每月不包括月末最后{{scope.row.unordergoodsdate}}天</div>
						<div style="white-space: pre-wrap" v-if="scope.row.orderGoodsType === 3">每隔{{scope.row.orderGoodsDate}}天可订货</div>
					</template>
				</el-table-column>
				<el-table-column
					label="订货时间"
					prop='orderGoodsTimeFlag'
					min-width="180"
					align="center">
					<template slot-scope="scope">
						<div>
							<div v-if="scope.row.orderGoodsTimeFlag === 0">不限制</div>
							<div v-else>
								<div v-for="(item, index) in getOrderTimeList(scope.row)" :key="index">
									<span v-if="isNextDayTime(item.beginTime, item.endTime, scope.row.orderGoodsTimeFlag)">
										{{item.beginTime}}-次日{{item.endTime}}
									</span>
									<span v-else>
										{{item.beginTime}}-{{item.endTime}}
									</span>
								</div>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column fixed="right" v-if="AuthorityList['03_0006_0003_00']" label="操作" width="100" align="center">
					<template slot-scope="scope">
						<el-button size="mini" type='text' @click="deleteClick(scope.row, 'single')">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div style="margin-top:5px">
				<el-pagination
				@size-change="handleSizeChange"
				@current-change="handlePageChange"
				:current-page="page.num"
				:page-sizes="[20, 40, 60, 100, 300]"
				:page-size="page.size"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total">
				</el-pagination>
			</div>
			<el-dialog class="detail-dialog-title" title="添加商品" top='60px' :before-close='closeAdd' :visible.sync="addModal" width='1200px' :close-on-click-modal="false">
				<addGood v-if="addModal" :addModal='addModal' :customerName='customerName' :customerId="customerId" @cancel='closeAdd'/>
			</el-dialog>
			<el-dialog class="detail-dialog-title" title="批量设置" top='60px' :before-close='cancelMuti' :visible.sync="mutiModel" width='580px' :close-on-click-modal="false">
				<Muti v-if='mutiModel' :ids='ids' :tableData="tableData" @cancel='cancelMuti'></Muti>
			</el-dialog>
			<el-dialog class="detail-dialog-title" title="同步到其他客户" top='60px' :before-close='closeCopy' :visible.sync="copyModal" width='1200px' :close-on-click-modal="false">
				<copy v-if='copyModal' :customerName='customerName' :customerId="customerId" :copyModal='copyModal' :syscode='syscode' :isRelationship='true' :ppIds='ids' @cancel='closeCopy' ref="refCopy"/>
			</el-dialog>
			<el-dialog title="提示" class="detail-dialog-title" top='60px' :visible.sync="errorMsgModel" width='400px' :close-on-click-modal="false">
				<div style="margin-bottom:10rpx;max-height:250px;overflow:auto">
					<div class="errormsgText" v-for="(item,index) in errorMsgList" :key='index' >
						{{item}}
					</div>
				</div>
				<div style="width:100%;text-align: center;margin-top:10px">
					<el-button size="small" style="width: 120px;" plain type="primary" @click="errorMsgClick">确认</el-button>
				</div>
			</el-dialog>
		</div>
	</div>
</template>
<script>
import addGood from '@/components/cusOrderScheme/addScheme.vue'
import copy from '@/components/cusOrderScheme/copy.vue'
import Muti from '@/components/cusOrderScheme/schemeMuti.vue'
const tableHeight1 = 'calc(100% - 40px)'
export default {
	name: 'table-box',
	components: {
		addGood, copy, Muti
	},
	props: {
		id: String
	},
	data () {
		return {
			cusCate: '0',
			cusName: '',
			shopid: '',
			syscode: '',
			customerName: '',
			addModal: false,
			copyModal: false,
			pName: '',
			tableHeight: tableHeight1,
			page: {
				size: 20,
				num: 1
			},
			total: null,
			tableData: [],
			errorMsgModel: false,
			errorMsgList: [],
			AuthorityList: {
				'03_0006_0001_00': false,
				'03_0006_0002_00': false,
				'03_0006_0003_00': false,
				'03_0006_0004_00': false,
				'03_0006_0005_00': false
			},
			bc: [],
			sc: [],
			bigcategoryview: 0,
			bigTypeCategory: '0',
			smallTypeCategory: '0',
			pcode: '',
			matchcode: '',
			tableSelectUtils: this.$fxUtils.tableSelectUtils({
				key: 'id',
				selectHandler: this.tableSelectUtilsHandler
			}),
			shopIds: [],
			shopNameList: [],
			mutiModel: false,
			list: [],
			cusCateList: [],
			customerId: '',
			customercategoryId: '',
			keyword: '',
			customercategoryIds: '',
			isChoose: false
		}
	},
	created () {
		this.getAuthority('03_0006_0000_00')
		this.getBigCategory()
		this.getSmalCategory()
		this.getShopList()
		this.getCustomer()
	},
	computed: {
		ids () {
			return this.tableSelectUtils.getSelectRows()
		}
	},
	methods: {
		getCustomer () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customerCategory/list`
			}).then(res => {
				if (res.result) {
					this.cusCateList = res.data.childNode
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		changeData (data, flag) {
			console.log(data)
			this.customerId = data.cusId
			this.customerName = data.cusName
			this.isChoose = data.isChoose
			this.keyword = data.keyword
			this.customercategoryId = data.cusCategoryId
			this.page = {
				size: 20,
				num: 1
			}
			this.total = 0
			this.tableData = []
			if (flag) {
				this.tableReload()
			} else {
				this.$message({
					message: '请点击查询获取数据！',
					type: 'warning'
				})
			}
			this.tableSelectUtils.clear()
			this.$refs.table.doLayout()
		},
		cancelMuti (data) {
			this.mutiModel = false
			this.tableReload()
			if (data === 1) {
				this.tableSelectUtils.clear()
			}
		},
		mutiCLick () {
			if (this.ids.length === 0) {
				this.$message.error('请选择至少一个商品！')
				return false
			}
			this.mutiModel = true
		},
		bcChange (value) {
			this.smallTypeCategory = '0'
			this.bigTypeCategory = '' + value
			this.getSmalCategory()
		},
		getBigCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getBigCategory`
			}).then(res => {
				if (res.result) {
					this.bc = res.data
				}
			})
		},
		getSmalCategory () {
			let params = {
				pid: this.bigTypeCategory
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getSmalCategory`,
				data: params
			}).then(res => {
				if (res.result) {
					this.sc = res.data
				}
			})
		},
		tableSelectUtilsHandler (row) {
			return row
		},
		errorMsgClick () {
			this.errorMsgModel = false
		},
		// 是否开启小类
		checkSmallCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.bigcategoryview = res.bigcategoryview
				this.matchbillcenterflag = res.matchbillcenterflag === 1
			})
		},
		getAuthority (pid) {
			let params = {
				pId: pid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		closeAdd () {
			this.addModal = false
			this.page = {
				size: 20,
				num: 1
			}
			this.tableReload()
		},
		closeCopy () {
			this.copyModal = false
			this.$refs.refCopy.name = ''
			this.$refs.refCopy.lineName = ''
			this.$refs.refCopy.customercategoryid = -1
			this.$refs.refCopy.disabledflag = 2
			this.page = {
				size: 20,
				num: 1
			}
			this.tableReload()
		},
		getCode () {
			let params = {
				id: this.customerId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/findCustomerDetailInfo`,
				data: params
			}).then(res => {
				if (res.result) {
					this.syscode = res.data.syscode + ''
					this.copyModal = true
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		synchroClick () {
			if (this.isChoose) {
				this.getCode(3)
			} else {
				this.$message.error('请选择客户')
			}
		},
		addClick () {
			if (this.isChoose) {
				this.addModal = true
			} else {
				this.$message.error('请选择客户')
			}
		},
		search () {
			this.tableSelectUtils.clear()
			this.page = {
				size: 20,
				num: 1
			}
			this.tableReload()
		},
		clear () {
			this.pName = ''
			this.bigTypeCategory = '0'
			this.smallTypeCategory = '0'
			this.pcode = ''
			this.shopIds = []
			this.cusName = ''
			this.customercategoryIds = ''
			this.matchcode = ''
			this.search()
		},
		deleteClick (data, type) {
			console.log(data)
			let params = {}
			let msg = ''
			if (type === 'single') {
				let orderGoodsDate = this.orderGoodsTypeInit(data)
				let orderGoodsTimeFlag = this.orderGoodsTimeFlagInit(data)
				let text = `删除“客户：${data.customerName}”的“订货方案：${data.productName}，${data.shopName}，${orderGoodsDate}，${orderGoodsTimeFlag}”`
				msg = text
			} else {
				let nameArr = []
				this.list.forEach(item => {
					let orderGoodsDate = this.orderGoodsTypeInit(item)
					let orderGoodsTimeFlag = this.orderGoodsTimeFlagInit(item)
					let text = `删除“客户：${item.customerName}”的“订货方案：${item.productName}，${item.shopName}，${orderGoodsDate}，${orderGoodsTimeFlag}”`
					nameArr.push(text)
				})
				msg = nameArr.join(',')
			}
			let url = window.location.href.split('?')[0]
			url = url.replace(window.location.origin, '').substring(1)
			params.ids = type === 'single' ? [data.id] : data
			params.logMessage = {
				message: msg,
				referer: url
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/delProductOrderGoodsDate`,
				data: params
			}).then(res => {
				if (res.result) {
					this.tableReload()
					this.tableSelectUtils.del(data.relProductCustomerId)
					this.$message.success('删除成功！')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		orderGoodsTypeInit (data) {
			let text = ''
			switch (data.orderGoodsType) {
			case 0:
				text = '每天订货'
				break
			case 1:
				text = `每周${data.orderGoodsDate}订货`
				break
			case 2:
				text = `每月${data.orderGoodsDate}订货`
				if (data.monthEndFlag === 1) {
					text = text + '每月月末最后一天订货'
				}
				break
			case 3:
				text = `每隔${data.orderGoodsDate}天可订货`
				break
			}
			return text
		},
		isNextDayTime (beginTime, endTime, orderGoodsTimeFlag) {
			if (beginTime && endTime) {
				const begin = beginTime.split(':')
				const end = endTime.split(':')
				const beginMinutes = parseInt(begin[0]) * 60 + parseInt(begin[1])
				const endMinutes = parseInt(end[0]) * 60 + parseInt(end[1])
				return endMinutes < beginMinutes
			}
			return false
		},
		getOrderTimeList (data) {
			if (data.times && data.times.length) {
				return data.times
			}
			return [{
				beginTime: data.beginTime,
				endTime: data.endTime
			}]
		},
		formatOrderTimeRange (item) {
			if (item.beginTime && item.endTime) {
				if (this.isNextDayTime(item.beginTime, item.endTime)) {
					return `${item.beginTime}-次日${item.endTime}`
				}
				return `${item.beginTime}-${item.endTime}`
			}
			return `${item.beginTime || ''}-${item.endTime || ''}`
		},
		orderGoodsTimeFlagInit (data) {
			if (data.orderGoodsTimeFlag === 0) {
				return '不限制'
			}
			return this.getOrderTimeList(data).map(item => this.formatOrderTimeRange(item)).join('、')
		},
		deleteListClick () {
			if (this.ids.length === 0) {
				this.$message.error('请勾选商品')
				return false
			}
			this.$confirm('是否要删除勾选的商品', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let ids = []
				this.ids.forEach(item => {
					ids.push(item.id)
				})
				this.deleteClick(ids, 'batch')
			}).catch(() => {
			})
		},
		handleSelectionChange (data) {
			this.tableSelectUtils.selectToggle(this.tableData, data)
			this.list = data
		},
		tableReload () {
			let params = {
				customercategoryId: this.customercategoryId,
				customercategoryIds: this.customercategoryIds,
				customerId: this.customerId,
				keyword: this.keyword,
				customerName: this.cusName,
				shopIds: this.shopIds,
				bigCategoryId: this.bigTypeCategory,
				smallCategoryId: this.smallTypeCategory,
				productName: this.pName,
				page: this.page.num,
				size: this.page.size,
				productCode: this.pcode,
				productMatchCode: this.matchcode
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/getProductOrderGoodsDateList`,
				data: params
			}).then(res => {
				console.log(res.recordList)
				this.tableData = res.recordList ? res.recordList : []
				this.total = res.recordCount
				this.$nextTick(() => {
					this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.table)
				})
			})
		},
		handleSizeChange (val) {
			this.page.num = 1
			this.page.size = val
			this.tableReload()
		},
		handlePageChange (val) {
			this.page.num = val
			this.tableReload()
		},
		getShopList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/selectShopList`
			}).then(res => {
				this.shopNameList = res
				console.log(res)
			})
		}
	}
}
</script>
<style lang="stylus" scoped>
.container1{
	width: 100%;
	flex-direction: column !important;
	display: flex
	.batch-register-btn{
		cursor :pointer;
		color: var(--fx-primary-color);
		font-size: 12px;
		margin-left: 10px;
        display: flex;
        width: 100px;
        height: 32px;
        justify-content center;
        align-items center;
	}
	.excel-icon {
		display inline-block
		height 20px
		width 20px
		background-repeat no-repeat
		background-position center
		&.import-excel-icon {
			background-image: url('~images/icon/import-excel-icon.png')
		}
		&.export-excel-icon {
			background-image: url('~images/icon/export-excel-icon.png')
		}
	}
	.errormsgText{
		width:100%;
		text-align :left
		line-height:30px;
	}
	.cusos-search {
		width:100%;
		display: flex;
		line-height: 40px;
		border-bottom 1px solid #dce2fd
	}
	.search-box{
		// padding-bottom :10px;
		// margin-top :10px;
		display:flex;
		flex-flow: row;
		flex-wrap:wrap;
		.input-box{
			text-align :left
			// width: 290px;
			margin-bottom:10px
			&>span {
				width: 85px;
				display: inline-block;
				text-align: right;
			}
			.name-input {
				width: 160px;
				margin-right: 10px;
			}
		}
	}
	.input-box-btn{
		width: 150px;
		flex-shrink: 0
	}
	.btn-ship-box{
		margin-top:10px;
		display :flex
	}
	.table-box{
		flex: 1
		margin-top:8px;
		min-height:200px;
	}
}

</style>
<style lang="stylus">
.cell{
	padding: 0 !important
}
.el-dialog__header{
    text-align left
}
.el-dialog__body {
	padding-top: 10px;
	padding-bottom: 10px
}
</style>
